if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;

        setTimeout(() => this.show(), delay * 1000);

        if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));
      }

      // Lock pointer-events immediately when banner starts showing
      // so the overlay never gets a chance to intercept clicks.
      beforeShow() {
        this._lockPointerEvents();
      }

      // Override hide() so the banner only closes when explicitly dismissed
      // (Accept or Decline buttons). Clicks outside the banner are ignored.
      hide(force) {
        if (!force) return;
        super.hide();
      }

      acceptPolicy() {
        this.hide(true);
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);

        document.addEventListener('trackingConsentAccepted', () => {
          console.log('trackingConsentAccepted event fired');
        });
      }

      declinePolicy() {
        this.hide(true);
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
        this._restorePointerEvents();
      }

      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
        this._lockPointerEvents();
      }

      // Force pointer-events via inline style with !important priority.
      // This is the highest CSS priority possible and cannot be overridden
      // by any stylesheet rule (including theme.css ".drawer[open]" or
      // ".drawer[active]>.overlay").
      _lockPointerEvents() {
        const transparent = [
          this,
          this.overlay,
          this.querySelector('.drawer__inner'),
          this.querySelector('.drawer__header'),
          this.querySelector('.drawer__content'),
        ];
        transparent.forEach((el) => {
          if (el) el.style.setProperty('pointer-events', 'none', 'important');
        });

        const scrollable = this.querySelector('.drawer__scrollable');
        if (scrollable) scrollable.style.setProperty('pointer-events', 'auto', 'important');
      }

      _restorePointerEvents() {
        [
          this,
          this.overlay,
          this.querySelector('.drawer__inner'),
          this.querySelector('.drawer__header'),
          this.querySelector('.drawer__content'),
          this.querySelector('.drawer__scrollable'),
        ].forEach((el) => {
          if (el) el.style.removeProperty('pointer-events');
        });
      }
    }
  );
}
